/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';

import ContentBlock from '../components/ContentBlock';
import CarDetailsChange from '../components/CarDetailsChange/CarDetailsChange';
import CarPortal from '../components/CarPortal/CarPortal';
import CookieNew from '../components/CookieNew/CookieNew';
import HolidayModal from '../components/HolidayModal/HolidayModal';
import ImageWallSimple from '../components/ImageWallSimple/ImageWallSimple';
import KvSimple from '../components/KvSimple/KvSimple';
import KvSubSimple from '../components/KvSubSimple/KvSubSimple';
import NewCarsOffers from '../components/NewCarsOffers/NewCarsOffers';
import PageHoverButton from '../components/PageHoverButton/PageHoverButton';
import PromoModal from '../components/PromoModal/PromoModal';
import RegionModal from '../components/RegionModal/RegionModal';
import VIdeoComplex from '../components/VIdeoComplex/VIdeoComplex';
import VideoAuto from '../components/VideoAuto/VideoAuto';
import VideoComponent from '../components/VideoComponent/VideoComponent';
import WordRichSimple from '../components/WordRichSimple/WordRichSimple';
import StyleguideFieldUsageCheckbox from '../components/fields/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/fields/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/fields/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/fields/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/fields/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/fields/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/fields/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/fields/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/fields/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/fields/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/fields/Styleguide-FieldUsage-Text';
import GraphQLConnectedDemo from '../components/graphql/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/graphql/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/graphql/GraphQL-Layout';
import AboutUsAnimationBlock from '../components/pages/AboutUs/AboutUsAnimationBlock/AboutUsAnimationBlock';
import AboutUsImageBlock from '../components/pages/AboutUs/AboutUsImageBlock/AboutUsImageBlock';
import AboutUsSection from '../components/pages/AboutUs/AboutUsSection/AboutUsSection';
import AboutUsHero from '../components/pages/AboutUs/Hero/AboutUsHero';
import AboutUsTextBlock from '../components/pages/AboutUs/TextBlock/AboutUsTextBlock';
import CarModelBookTestDrive from '../components/pages/CarModel/BookTestDrive/CarModelBookTestDrive';
import CarModelDetails from '../components/pages/CarModel/CarDetails/CarModelDetails';
import Carousel from '../components/pages/CarModel/CarDetails/Carousel/Carousel';
import CarModelPrevNextButtons from '../components/pages/CarModel/CarDetails/Carousel/PrevNextButtons/CarModelPrevNextButtons';
import CarModelDesktop from '../components/pages/CarModel/CarDetails/Desktop/CarModelDesktop';
import Marks from '../components/pages/CarModel/CarDetails/Marks/Marks';
import CarModelMobile from '../components/pages/CarModel/CarDetails/Mobile/CarModelMobile';
import CarModelSecondTextBlock from '../components/pages/CarModel/CarModelSecondTextBlock/CarModelSecondTextBlock';
import CarModelTextBlock from '../components/pages/CarModel/CarModelTextBlock/CarModelTextBlock';
import CarModelStyles from '../components/pages/CarModel/CarStyles/CarModelStyles';
import CarModelVariants from '../components/pages/CarModel/CarStyles/Variants/CarModelVariants';
import CarModelConfigure from '../components/pages/CarModel/Configure/CarModelConfigure';
import DesignedForAdventureBlock from '../components/pages/CarModel/DesignedForAdventureBlock/DesignedForAdventureBlock';
import HorizontalScrollImages from '../components/pages/CarModel/DesignedForAdventureBlock/HorizontalScrollImages/HorizontalScrollImages';
import CarModelEngine from '../components/pages/CarModel/Engine/CarModelEngine';
import CarModelEngineCarousel from '../components/pages/CarModel/Engine/Carousel/CarModelEngineCarousel';
import CarModelEnginePrevNextButtons from '../components/pages/CarModel/Engine/Carousel/PrevNextButtons/CarModelEnginePrevNextButtons';
import CarModelEngineDesktop from '../components/pages/CarModel/Engine/Desktop/CarModelEngineDesktop';
import CarModelEngineMarks from '../components/pages/CarModel/Engine/Marks/CarModelEngineMarks';
import CarModelEngineMobile from '../components/pages/CarModel/Engine/Mobile/CarModelEngineMobile';
import ExteriorInterior from '../components/pages/CarModel/ExteriorInterior/ExteriorInterior';
import CarModelGreenFutureBlock from '../components/pages/CarModel/GreenFutureBlock/CarModelGreenFutureBlock';
import CarModelHero from '../components/pages/CarModel/Hero/CarModelHero';
import IntelligentSystemBlock from '../components/pages/CarModel/IntelligentSystemBlock/IntelligentSystemBlock';
import ScrollFixedImages from '../components/pages/CarModel/IntelligentSystemBlock/ScrollFixedImages/ScrollFixedImages';
import CarModelInteractive from '../components/pages/CarModel/InteractiveBooking/CarModelInteractive';
import CarModelArrowRight from '../components/pages/CarModel/InteractiveBooking/ArrowRight/CarModelArrowRight';
import CarModelCircularProgress from '../components/pages/CarModel/InteractiveBooking/CircularProgress/CarModelCircularProgress';
import CarModelLuxuryBlock from '../components/pages/CarModel/LuxuryBlock/CarModelLuxuryBlock';
import CarModelMeetBlock from '../components/pages/CarModel/MeetBlock/CarModelMeetBlock';
import CarModelSpecifications from '../components/pages/CarModel/Specifications/CarModelSpecifications';
import Analytics from '../components/pages/CarModel/Specifications/Analytics/Analytics';
import SpecificationsToolbar from '../components/pages/CarModel/Specifications/Toolbar/SpecificationsToolbar';
import CookiePolicy from '../components/pages/Common/CookiePolicy/CookiePolicy';
import CookiePolicyMain from '../components/pages/Common/CookiePolicy/Main/CookiePolicyMain';
import PrivacyPolicy from '../components/pages/Common/PrivacyPolicy/PrivacyPolicy';
import PrivacyPolicyMain from '../components/pages/Common/PrivacyPolicy/Main/PrivacyPolicyMain';
import PrivacyPolicyDates from '../components/pages/Common/PrivacyPolicy/Main/Dates/PrivacyPolicyDates';
import RichTextMain from '../components/pages/Common/RichTextMain/RichTextMain';
import ContactForm from '../components/pages/ContactUs/ContactForm';
import ContactUsForm from '../components/pages/ContactUs/Form/ContactUsForm';
import CustomPhoneInputField from '../components/pages/ContactUs/Form/CustomPhoneInputField/CustomPhoneInputField';
import ThankYouModal from '../components/pages/ContactUs/ThankYouModal/ThankYouModal';
import Cookie from '../components/pages/Cookie/Cookie';
import FindDealer from '../components/pages/FindDealer/MapSection/FindDealer';
import DealersMap from '../components/pages/FindDealer/MapSection/DealersMap/DealersMap';
import smoothPanAndZoom from '../components/pages/FindDealer/MapSection/DealersMap/smoothPanAndZoom';
import ContactSection from '../components/pages/FindDealer/MapSection/Overlay/ContactSection';
import InfoSection from '../components/pages/FindDealer/MapSection/Overlay/InfoSection';
import InfoSectionMobile from '../components/pages/FindDealer/MapSection/Overlay/InfoSectionMobile';
import Overlay from '../components/pages/FindDealer/MapSection/Overlay/Overlay';
import SearchSection from '../components/pages/FindDealer/MapSection/Overlay/SearchSection';
import ThankYouSection from '../components/pages/FindDealer/MapSection/Overlay/ThankYouSection';
import RegularOpeningHours from '../components/pages/FindDealer/MapSection/Overlay/RegularOpeningHours/RegularOpeningHours';
import FleetContentImage from '../components/pages/Fleet/ContentAndImage/FleetContentImage';
import FleetContentImageBlock from '../components/pages/Fleet/ContentAndImageBlock/FleetContentImageBlock';
import FleetDealerSupport from '../components/pages/Fleet/DealerSupport/FleetDealerSupport';
import FleetCard from '../components/pages/Fleet/DealerSupport/Card/FleetCard';
import FleetDisclaimer from '../components/pages/Fleet/Disclaimer/FleetDisclaimer';
import FleetHero from '../components/pages/Fleet/Hero/FleetHero';
import FleetHow from '../components/pages/Fleet/How/FleetHow';
import FleetMaximise from '../components/pages/Fleet/MaximiseEfficiency/FleetMaximise';
import FleetMeetCar from '../components/pages/Fleet/MeetTheCar/FleetMeetCar';
import FleetPartnerShip from '../components/pages/Fleet/Partnership/FleetPartnerShip';
import Footer from '../components/pages/Footer/Footer';
import MobileNavigation from '../components/pages/Footer/MobileNavigation/MobileNavigation';
import Accordion from '../components/pages/Footer/MobileNavigation/Accordion/Accordion';
import Navigation from '../components/pages/Footer/Navigation/Navigation';
import SocialNetworks from '../components/pages/Footer/SocialNetworks/SocialNetworks';
import Header from '../components/pages/Header/Header';
import Backdrop from '../components/pages/Header/Backdrop/Backdrop';
import Burger from '../components/pages/Header/Burger/Burger';
import LanguageSelector from '../components/pages/Header/LanguageSelector/LanguageSelector';
import Menu from '../components/pages/Header/Menu/Menu';
import Arrow from '../components/pages/Icons/Arrow';
import CheckIcon from '../components/pages/Icons/CheckIcon';
import Chevron from '../components/pages/Icons/Chevron';
import DoubleArrow from '../components/pages/Icons/DoubleArrow';
import Facebook from '../components/pages/Icons/Facebook';
import Instagram from '../components/pages/Icons/Instagram';
import Linkedin from '../components/pages/Icons/Linkedin';
import Logo from '../components/pages/Icons/Logo';
import NewsArrow from '../components/pages/Icons/NewsArrow';
import Next from '../components/pages/Icons/Next';
import PaginationArrow from '../components/pages/Icons/PaginationArrow';
import Prev from '../components/pages/Icons/Prev';
import ShareFacebook from '../components/pages/Icons/ShareFacebook';
import ShareLinkedin from '../components/pages/Icons/ShareLinkedin';
import ShareWhatsApp from '../components/pages/Icons/ShareWhatsApp';
import Youtube from '../components/pages/Icons/Youtube';
import NewsDetail from '../components/pages/News/Detail/NewsDetail';
import Content from '../components/pages/News/Detail/Article/Content/Content';
import ShareTo from '../components/pages/News/Detail/Article/Content/ShareTo/ShareTo';
import Hero from '../components/pages/News/Detail/Article/Hero/Hero';
import RelatedArticles from '../components/pages/News/Detail/Article/RelatedArticles/RelatedArticles';
import NewDetailRelatedList from '../components/pages/News/Detail/Article/RelatedArticles/List/NewDetailRelatedList';
import NewsList from '../components/pages/News/NewsList/Articles/NewsList';
import NewsListArticleList from '../components/pages/News/NewsList/Articles/List/NewsListArticleList';
import Pagination from '../components/pages/News/NewsList/Articles/Pagination/Pagination';
import Toolbar from '../components/pages/News/NewsList/Articles/Toolbar/Toolbar';
import NewsListHero from '../components/pages/News/NewsList/Hero/NewsListHero';
import NotFound from '../components/pages/NotFound/NotFound';
import carconfigurator from '../components/pages/car-configurator/car-configurator';
import ChooseBrand from '../components/pages/car-configurator/ChooseBrand/ChooseBrand';
import ChooseBrandDemo from '../components/pages/car-configurator/ChooseBrand/ChooseBrandDemo';
import ConfiguratorMain from '../components/pages/car-configurator/Main/ConfiguratorMain';
import stepsData from '../components/pages/car-configurator/Main/stepsData';
import utils from '../components/pages/car-configurator/Main/utils';
import ConfiguratorCarType from '../components/pages/car-configurator/Main/CarType/ConfiguratorCarType';
import ConfiguratorDesktop from '../components/pages/car-configurator/Main/CarType/Desktop/ConfiguratorDesktop';
import ConfiguratorMobile from '../components/pages/car-configurator/Main/CarType/Mobile/ConfiguratorMobile';
import ConfiguratorColour from '../components/pages/car-configurator/Main/Colour/ConfiguratorColour';
import ConfiguratorInterior from '../components/pages/car-configurator/Main/Interior/ConfiguratorInterior';
import ConfiguratorSteps from '../components/pages/car-configurator/Main/Steps/ConfiguratorSteps';
import ConfiguratorSummary from '../components/pages/car-configurator/Main/Summary/ConfiguratorSummary';
import ConfiguratorVersion from '../components/pages/car-configurator/Main/Version/ConfiguratorVersion';
import ConfiguratorTitleBlock from '../components/pages/car-configurator/TitleBlock/ConfiguratorTitleBlock';
import OverViewImageBlock from '../components/pages/channel-overview/ContentAndImageBlock/OverViewImageBlock';
import OverViewCorporateBlock from '../components/pages/channel-overview/CorporateBlock/OverViewCorporateBlock';
import OverViewHero from '../components/pages/channel-overview/Hero/OverViewHero';
import OverViewSpeakWithTeam from '../components/pages/channel-overview/SpeakWithTeam/OverViewSpeakWithTeam';
import downloadcenter from '../components/pages/download-center/download-center';
import DownloadCarInfo from '../components/pages/download-center/CarInfo/DownloadCarInfo';
import DownloadCars from '../components/pages/download-center/CarInfo/Cars/DownloadCars';
import DownloadCar from '../components/pages/download-center/CarInfo/Cars/Car/DownloadCar';
import DownloadSegmented from '../components/pages/download-center/CarInfo/Segmented/DownloadSegmented';
import DownloadHero from '../components/pages/download-center/Hero/DownloadHero';
import finance from '../components/pages/finance/finance';
import FinanceSegmented from '../components/pages/finance/FinanceSegmented/FinanceSegmented';
import FinanceCalculator from '../components/pages/finance-calculator/FinanceCalculator';
import financecalculator from '../components/pages/finance-calculator/finance-calculator';
import FinanceCalculatorHero from '../components/pages/finance-calculator/Hero/FinanceCalculatorHero';
import FinanceCalculatorMainSection from '../components/pages/finance-calculator/MainSection/FinanceCalculatorMainSection';
import FinanceCalculatorCalculator from '../components/pages/finance-calculator/MainSection/Calculator/FinanceCalculatorCalculator';
import FinanceCalculatorCarList from '../components/pages/finance-calculator/MainSection/CarList/FinanceCalculatorCarList';
import FinanceCalculatorSteps from '../components/pages/finance-calculator/MainSection/Steps/FinanceCalculatorSteps';
import FinanceCalculatorCard from '../components/pages/finance-calculator/components/FinanceCalculatorCard';
import fleetBusiness from '../components/pages/fleet-business/fleetBusiness';
import FleetThankYouModal from '../components/pages/fleet-business/FleetThankYouModal/FleetThankYouModal';
import FleetBusinessFrom from '../components/pages/fleet-business/Form/FleetBusinessFrom';
import FleetCustomPhoneInputField from '../components/pages/fleet-business/Form/FleetCustomPhoneInputField/FleetCustomPhoneInputField';
import ExcellentPower from '../components/pages/fleet-sales/ExcellentPower/ExcellentPower';
import FleetBusiness from '../components/pages/fleet-sales/FleetBusiness/FleetBusiness';
import FleetSalesHero from '../components/pages/fleet-sales/FleetSalesHero/FleetSalesHero';
import FleetSalesImageCarousel from '../components/pages/fleet-sales/FleetSalesImageCarousel/FleetSalesImageCarousel';
import FleetSalesImageCarouselCard from '../components/pages/fleet-sales/FleetSalesImageCarousel/FleetSalesImageCarouselCard/FleetSalesImageCarouselCard';
import FleetSalesImageMobile from '../components/pages/fleet-sales/FleetSalesImageMobile/FleetSalesImageMobile';
import FleetSaleScrollFixedImages from '../components/pages/fleet-sales/FleetSalesImageMobile/FleetSaleScrollFixedImages/FleetSaleScrollFixedImages';
import FleetSalesVideoHighlightsSection from '../components/pages/fleet-sales/FleetSalesVideoHighlightsSection/FleetSalesVideoHighlightsSection';
import VideoHighlightsSectionCard from '../components/pages/fleet-sales/FleetSalesVideoHighlightsSection/VideoHighlightsSectionCard/VideoHighlightsSectionCard';
import FuelCostsSavingsCalculator from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/FuelCostsSavingsCalculator';
import AverageConsumption from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/AverageConsumption/AverageConsumption';
import AverageConsumptionSegmented from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/AverageConsumption/AverageConsumptionSegmented/AverageConsumptionSegmented';
import FuelPrice from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/AverageConsumption/FuelPrice/FuelPrice';
import FuelCostsSavingsCalculatorSliders from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/FuelCostsSavingsCalculatorSliders/FuelCostsSavingsCalculatorSliders';
import CustomSlider from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/FuelCostsSavingsCalculatorSliders/CustomSlider/CustomSlider';
import Savings from '../components/pages/fleet-sales/FuelCostsSavingsCalculator/Savings/Savings';
import PlugInHybrid from '../components/pages/fleet-sales/PlugInHybrid/PlugInHybrid';
import home from '../components/pages/home/home';
import Features from '../components/pages/home/Features/Features';
import CarModelCarousel from '../components/pages/home/Features/CarModelCarousel/CarModelCarousel';
import Slide from '../components/pages/home/Features/CarModelCarousel/Slide/Slide';
import FeaturesButtons from '../components/pages/home/Features/CarModelCarousel/Slide/Buttons/FeaturesButtons';
import FeaturesList from '../components/pages/home/Features/CarModelCarousel/Slide/List/FeaturesList';
import PrevNextButtons from '../components/pages/home/Features/CarModelCarousel/Slide/PrevNextButtons/PrevNextButtons';
import Segmented from '../components/pages/home/Features/Segmented/Segmented';
import InteractiveBooking from '../components/pages/home/InteractiveBooking/InteractiveBooking';
import ArrowRight from '../components/pages/home/InteractiveBooking/ArrowRight/ArrowRight';
import CircularProgress from '../components/pages/home/InteractiveBooking/CircularProgress/CircularProgress';
import NewHero from '../components/pages/home/NewHero/NewHero';
import CarSwiper from '../components/pages/home/NewHero/CarSwiper/CarSwiper';
import News from '../components/pages/home/News/News';
import Desktop from '../components/pages/home/News/Desktop/Desktop';
import ContinuousCarousel from '../components/pages/home/News/Desktop/ContinuousCarousel/ContinuousCarousel';
import useAnimationLoop from '../components/pages/home/News/Desktop/ContinuousCarousel/useAnimationLoop';
import HomeNewsList from '../components/pages/home/News/Desktop/ContinuousCarousel/List/HomeNewsList';
import Mobile from '../components/pages/home/News/Mobile/Mobile';
import ParallaxCard from '../components/pages/home/ParallaxCard/ParallaxCard';
import CardButtons from '../components/pages/home/ParallaxCard/CardButtons/CardButtons';
import TermsAndConditions from '../components/pages/home/TermsAndConditionsSection/TermsAndConditions';
import Video from '../components/pages/home/Video/Video';
import motabilitypricelistjaecoo7 from '../components/pages/motability-pricelist-jaecoo7/motability-pricelist-jaecoo7';
import Motability7ContactSection from '../components/pages/motability-pricelist-jaecoo7/ContactSection/Motability7ContactSection';
import Motability7HeroSection from '../components/pages/motability-pricelist-jaecoo7/HeroSection/Motability7HeroSection';
import Motability7SelectCarSection from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/Motability7SelectCarSection';
import Motability7SelectedCarCarousel from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/SelectedCarCarousel/Motability7SelectedCarCarousel';
import Motability7Slide from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/SelectedCarCarousel/Slide/Motability7Slide';
import Motability7Buttons from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/SelectedCarCarousel/Slide/Buttons/Motability7Buttons';
import Motability7List from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/SelectedCarCarousel/Slide/List/Motability7List';
import Motability7Switch from '../components/pages/motability-pricelist-jaecoo7/SelectCarSection/Switch/Motability7Switch';
import OffersHero from '../components/pages/offers/OffersHero/OffersHero';
import CarSelection from '../components/pages/oldOffers/CarSelection/CarSelection';
import CarSelectionList from '../components/pages/oldOffers/CarSelection/CarList/CarSelectionList';
import OffersList from '../components/pages/oldOffers/OffersList/OffersList';
import OffersAchieving from '../components/pages/oldOffers/OffersList/Achieving/OffersAchieving';
import OffersAchievingList from '../components/pages/oldOffers/OffersList/Achieving/List/OffersAchievingList';
import OldOffersHero from '../components/pages/oldOffers/OffersList/Hero/OldOffersHero';
import SelectedCarDetail from '../components/pages/oldOffers/SelectedCarDetail/SelectedCarDetail';
import SCarDetaiDescriptionSection from '../components/pages/oldOffers/SelectedCarDetail/DescriptionSection/SCarDetaiDescriptionSection';
import SCarDetailHeroSection from '../components/pages/oldOffers/SelectedCarDetail/HeroSection/SCarDetailHeroSection';
import SCarDetaiImagesSection from '../components/pages/oldOffers/SelectedCarDetail/ImagesSection/SCarDetaiImagesSection';
import SCarDetaiSecondImageSection from '../components/pages/oldOffers/SelectedCarDetail/SecondImageSection/SCarDetaiSecondImageSection';
import SCarDetaiSwitch from '../components/pages/oldOffers/SelectedCarDetail/Switch/SCarDetaiSwitch';
import SCarDetaiTermsAndConditionsSection from '../components/pages/oldOffers/SelectedCarDetail/TermsAndConditionsSection/SCarDetaiTermsAndConditionsSection';
import roadsideassistance from '../components/pages/roadside-assistance/roadside-assistance';
import RoadsideAssistance from '../components/pages/roadside-assistance/RoadsideAssistance/RoadsideAssistance';
import RoadsideContactRoadside from '../components/pages/roadside-assistance/RoadsideAssistance/ContactRoadside/RoadsideContactRoadside';
import RoadsideHero from '../components/pages/roadside-assistance/RoadsideAssistance/Hero/RoadsideHero';
import RoadsideNeedServicing from '../components/pages/roadside-assistance/RoadsideAssistance/NeedServicing/RoadsideNeedServicing';
import RoadsideBlock from '../components/pages/roadside-assistance/RoadsideAssistance/RoadsideBlock/RoadsideBlock';
import serviceandmaintenance from '../components/pages/service-and-maintenance/service-and-maintenance';
import ServiceAndMaintenance from '../components/pages/service-and-maintenance/ServiceAndMaintenance/ServiceAndMaintenance';
import ServiceAndMaintenanceBookService from '../components/pages/service-and-maintenance/ServiceAndMaintenance/BookService/ServiceAndMaintenanceBookService';
import ServiceAndMaintenanceHero from '../components/pages/service-and-maintenance/ServiceAndMaintenance/Hero/ServiceAndMaintenanceHero';
import ServiceAppointment from '../components/pages/service-and-maintenance/ServiceAndMaintenance/ServiceAppointment/ServiceAppointment';
import ServiceAndMaintenanceStepItem from '../components/pages/service-and-maintenance/ServiceAndMaintenance/ServiceAppointment/StepItem/ServiceAndMaintenanceStepItem';
import ServiceAndMaintenanceSteps from '../components/pages/service-and-maintenance/ServiceAndMaintenance/ServiceAppointment/Steps/ServiceAndMaintenanceSteps';
import serviceplan from '../components/pages/service-plan/service-plan';
import PlanFindADealer from '../components/pages/service-plan/FindADealer/PlanFindADealer';
import PlanHeroSection from '../components/pages/service-plan/HeroSection/PlanHeroSection';
import PlanServicePlanHighlight from '../components/pages/service-plan/ServicePlanHighlight/PlanServicePlanHighlight';
import PlanScrollFixedImages from '../components/pages/service-plan/ServicePlanHighlight/ScrollFixedImages/PlanScrollFixedImages';
import PlanWarrantySection from '../components/pages/service-plan/WarrantySection/PlanWarrantySection';
import Button from '../components/pages/ui/Button/Button';
import CustomDropdown from '../components/pages/ui/CustomDropdown/CustomDropdown';
import CustomInputDropdown from '../components/pages/ui/CustomInputDropdown/CustomInputDropdown';
import Loader from '../components/pages/ui/Loader/Loader';
import VinLookUp from '../components/pages/vin-lookup/VinLookUp';
import warranty from '../components/pages/warranty/warranty';
import WarrantyAboutSection from '../components/pages/warranty/AboutSection/WarrantyAboutSection';
import WarrantyHeroSection from '../components/pages/warranty/HeroSection/WarrantyHeroSection';
import WarrantyHighlightSection from '../components/pages/warranty/HighlightSection/WarrantyHighlightSection';
import WarrantyListSection from '../components/pages/warranty/ListSection/WarrantyListSection';
import StyleguideComponentParams from '../components/styleguide/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/styleguide/Styleguide-CustomRouteType';
import StyleguideEditFrame from '../components/styleguide/Styleguide-EditFrame';
import StyleguideLanguageSelector from '../components/styleguide/Styleguide-LanguageSelector';
import StyleguideLayoutReuse from '../components/styleguide/Styleguide-Layout-Reuse';
import StyleguideLayoutTabsTab from '../components/styleguide/Styleguide-Layout-Tabs-Tab';
import StyleguideLayoutTabs from '../components/styleguide/Styleguide-Layout-Tabs';
import StyleguideLayout from '../components/styleguide/Styleguide-Layout';
import StyleguideMultilingual from '../components/styleguide/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/styleguide/Styleguide-RouteFields';
import StyleguideSection from '../components/styleguide/Styleguide-Section';
import StyleguideSitecoreContext from '../components/styleguide/Styleguide-SitecoreContext';
import StyleguideSpecimen from '../components/styleguide/Styleguide-Specimen';
import StyleguideTracking from '../components/styleguide/Styleguide-Tracking';
import OptimizedImage from '../components/ui/OptimizedImage/OptimizedImage';

const components = new Map();

components.set('ContentBlock', ContentBlock);
components.set('CarDetailsChange', CarDetailsChange);
components.set('CarPortal', CarPortal);
components.set('CookieNew', CookieNew);
components.set('HolidayModal', HolidayModal);
components.set('ImageWallSimple', ImageWallSimple);
components.set('KvSimple', KvSimple);
components.set('KvSubSimple', KvSubSimple);
components.set('NewCarsOffers', NewCarsOffers);
components.set('PageHoverButton', PageHoverButton);
components.set('PromoModal', PromoModal);
components.set('RegionModal', RegionModal);
components.set('VIdeoComplex', VIdeoComplex);
components.set('VideoAuto', VideoAuto);
components.set('VideoComponent', VideoComponent);
components.set('WordRichSimple', WordRichSimple);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('AboutUsAnimationBlock', AboutUsAnimationBlock);
components.set('AboutUsImageBlock', AboutUsImageBlock);
components.set('AboutUsSection', AboutUsSection);
components.set('AboutUsHero', AboutUsHero);
components.set('AboutUsTextBlock', AboutUsTextBlock);
components.set('CarModelBookTestDrive', CarModelBookTestDrive);
components.set('CarModelDetails', CarModelDetails);
components.set('Carousel', Carousel);
components.set('CarModelPrevNextButtons', CarModelPrevNextButtons);
components.set('CarModelDesktop', CarModelDesktop);
components.set('Marks', Marks);
components.set('CarModelMobile', CarModelMobile);
components.set('CarModelSecondTextBlock', CarModelSecondTextBlock);
components.set('CarModelTextBlock', CarModelTextBlock);
components.set('CarModelStyles', CarModelStyles);
components.set('CarModelVariants', CarModelVariants);
components.set('CarModelConfigure', CarModelConfigure);
components.set('DesignedForAdventureBlock', DesignedForAdventureBlock);
components.set('HorizontalScrollImages', HorizontalScrollImages);
components.set('CarModelEngine', CarModelEngine);
components.set('CarModelEngineCarousel', CarModelEngineCarousel);
components.set('CarModelEnginePrevNextButtons', CarModelEnginePrevNextButtons);
components.set('CarModelEngineDesktop', CarModelEngineDesktop);
components.set('CarModelEngineMarks', CarModelEngineMarks);
components.set('CarModelEngineMobile', CarModelEngineMobile);
components.set('ExteriorInterior', ExteriorInterior);
components.set('CarModelGreenFutureBlock', CarModelGreenFutureBlock);
components.set('CarModelHero', CarModelHero);
components.set('IntelligentSystemBlock', IntelligentSystemBlock);
components.set('ScrollFixedImages', ScrollFixedImages);
components.set('CarModelInteractive', CarModelInteractive);
components.set('CarModelArrowRight', CarModelArrowRight);
components.set('CarModelCircularProgress', CarModelCircularProgress);
components.set('CarModelLuxuryBlock', CarModelLuxuryBlock);
components.set('CarModelMeetBlock', CarModelMeetBlock);
components.set('CarModelSpecifications', CarModelSpecifications);
components.set('Analytics', Analytics);
components.set('SpecificationsToolbar', SpecificationsToolbar);
components.set('CookiePolicy', CookiePolicy);
components.set('CookiePolicyMain', CookiePolicyMain);
components.set('PrivacyPolicy', PrivacyPolicy);
components.set('PrivacyPolicyMain', PrivacyPolicyMain);
components.set('PrivacyPolicyDates', PrivacyPolicyDates);
components.set('RichTextMain', RichTextMain);
components.set('ContactForm', ContactForm);
components.set('ContactUsForm', ContactUsForm);
components.set('CustomPhoneInputField', CustomPhoneInputField);
components.set('ThankYouModal', ThankYouModal);
components.set('Cookie', Cookie);
components.set('FindDealer', FindDealer);
components.set('DealersMap', DealersMap);
components.set('smoothPanAndZoom', smoothPanAndZoom);
components.set('ContactSection', ContactSection);
components.set('InfoSection', InfoSection);
components.set('InfoSectionMobile', InfoSectionMobile);
components.set('Overlay', Overlay);
components.set('SearchSection', SearchSection);
components.set('ThankYouSection', ThankYouSection);
components.set('RegularOpeningHours', RegularOpeningHours);
components.set('FleetContentImage', FleetContentImage);
components.set('FleetContentImageBlock', FleetContentImageBlock);
components.set('FleetDealerSupport', FleetDealerSupport);
components.set('FleetCard', FleetCard);
components.set('FleetDisclaimer', FleetDisclaimer);
components.set('FleetHero', FleetHero);
components.set('FleetHow', FleetHow);
components.set('FleetMaximise', FleetMaximise);
components.set('FleetMeetCar', FleetMeetCar);
components.set('FleetPartnerShip', FleetPartnerShip);
components.set('Footer', Footer);
components.set('MobileNavigation', MobileNavigation);
components.set('Accordion', Accordion);
components.set('Navigation', Navigation);
components.set('SocialNetworks', SocialNetworks);
components.set('Header', Header);
components.set('Backdrop', Backdrop);
components.set('Burger', Burger);
components.set('LanguageSelector', LanguageSelector);
components.set('Menu', Menu);
components.set('Arrow', Arrow);
components.set('CheckIcon', CheckIcon);
components.set('Chevron', Chevron);
components.set('DoubleArrow', DoubleArrow);
components.set('Facebook', Facebook);
components.set('Instagram', Instagram);
components.set('Linkedin', Linkedin);
components.set('Logo', Logo);
components.set('NewsArrow', NewsArrow);
components.set('Next', Next);
components.set('PaginationArrow', PaginationArrow);
components.set('Prev', Prev);
components.set('ShareFacebook', ShareFacebook);
components.set('ShareLinkedin', ShareLinkedin);
components.set('ShareWhatsApp', ShareWhatsApp);
components.set('Youtube', Youtube);
components.set('NewsDetail', NewsDetail);
components.set('Content', Content);
components.set('ShareTo', ShareTo);
components.set('Hero', Hero);
components.set('RelatedArticles', RelatedArticles);
components.set('NewDetailRelatedList', NewDetailRelatedList);
components.set('NewsList', NewsList);
components.set('NewsListArticleList', NewsListArticleList);
components.set('Pagination', Pagination);
components.set('Toolbar', Toolbar);
components.set('NewsListHero', NewsListHero);
components.set('NotFound', NotFound);
components.set('car-configurator', carconfigurator);
components.set('ChooseBrand', ChooseBrand);
components.set('ChooseBrandDemo', ChooseBrandDemo);
components.set('ConfiguratorMain', ConfiguratorMain);
components.set('stepsData', stepsData);
components.set('utils', utils);
components.set('ConfiguratorCarType', ConfiguratorCarType);
components.set('ConfiguratorDesktop', ConfiguratorDesktop);
components.set('ConfiguratorMobile', ConfiguratorMobile);
components.set('ConfiguratorColour', ConfiguratorColour);
components.set('ConfiguratorInterior', ConfiguratorInterior);
components.set('ConfiguratorSteps', ConfiguratorSteps);
components.set('ConfiguratorSummary', ConfiguratorSummary);
components.set('ConfiguratorVersion', ConfiguratorVersion);
components.set('ConfiguratorTitleBlock', ConfiguratorTitleBlock);
components.set('OverViewImageBlock', OverViewImageBlock);
components.set('OverViewCorporateBlock', OverViewCorporateBlock);
components.set('OverViewHero', OverViewHero);
components.set('OverViewSpeakWithTeam', OverViewSpeakWithTeam);
components.set('download-center', downloadcenter);
components.set('DownloadCarInfo', DownloadCarInfo);
components.set('DownloadCars', DownloadCars);
components.set('DownloadCar', DownloadCar);
components.set('DownloadSegmented', DownloadSegmented);
components.set('DownloadHero', DownloadHero);
components.set('finance', finance);
components.set('FinanceSegmented', FinanceSegmented);
components.set('FinanceCalculator', FinanceCalculator);
components.set('finance-calculator', financecalculator);
components.set('FinanceCalculatorHero', FinanceCalculatorHero);
components.set('FinanceCalculatorMainSection', FinanceCalculatorMainSection);
components.set('FinanceCalculatorCalculator', FinanceCalculatorCalculator);
components.set('FinanceCalculatorCarList', FinanceCalculatorCarList);
components.set('FinanceCalculatorSteps', FinanceCalculatorSteps);
components.set('FinanceCalculatorCard', FinanceCalculatorCard);
components.set('fleetBusiness', fleetBusiness);
components.set('FleetThankYouModal', FleetThankYouModal);
components.set('FleetBusinessFrom', FleetBusinessFrom);
components.set('FleetCustomPhoneInputField', FleetCustomPhoneInputField);
components.set('ExcellentPower', ExcellentPower);
components.set('FleetBusiness', FleetBusiness);
components.set('FleetSalesHero', FleetSalesHero);
components.set('FleetSalesImageCarousel', FleetSalesImageCarousel);
components.set('FleetSalesImageCarouselCard', FleetSalesImageCarouselCard);
components.set('FleetSalesImageMobile', FleetSalesImageMobile);
components.set('FleetSaleScrollFixedImages', FleetSaleScrollFixedImages);
components.set('FleetSalesVideoHighlightsSection', FleetSalesVideoHighlightsSection);
components.set('VideoHighlightsSectionCard', VideoHighlightsSectionCard);
components.set('FuelCostsSavingsCalculator', FuelCostsSavingsCalculator);
components.set('AverageConsumption', AverageConsumption);
components.set('AverageConsumptionSegmented', AverageConsumptionSegmented);
components.set('FuelPrice', FuelPrice);
components.set('FuelCostsSavingsCalculatorSliders', FuelCostsSavingsCalculatorSliders);
components.set('CustomSlider', CustomSlider);
components.set('Savings', Savings);
components.set('PlugInHybrid', PlugInHybrid);
components.set('home', home);
components.set('Features', Features);
components.set('CarModelCarousel', CarModelCarousel);
components.set('Slide', Slide);
components.set('FeaturesButtons', FeaturesButtons);
components.set('FeaturesList', FeaturesList);
components.set('PrevNextButtons', PrevNextButtons);
components.set('Segmented', Segmented);
components.set('InteractiveBooking', InteractiveBooking);
components.set('ArrowRight', ArrowRight);
components.set('CircularProgress', CircularProgress);
components.set('NewHero', NewHero);
components.set('CarSwiper', CarSwiper);
components.set('News', News);
components.set('Desktop', Desktop);
components.set('ContinuousCarousel', ContinuousCarousel);
components.set('useAnimationLoop', useAnimationLoop);
components.set('HomeNewsList', HomeNewsList);
components.set('Mobile', Mobile);
components.set('ParallaxCard', ParallaxCard);
components.set('CardButtons', CardButtons);
components.set('TermsAndConditions', TermsAndConditions);
components.set('Video', Video);
components.set('motability-pricelist-jaecoo7', motabilitypricelistjaecoo7);
components.set('Motability7ContactSection', Motability7ContactSection);
components.set('Motability7HeroSection', Motability7HeroSection);
components.set('Motability7SelectCarSection', Motability7SelectCarSection);
components.set('Motability7SelectedCarCarousel', Motability7SelectedCarCarousel);
components.set('Motability7Slide', Motability7Slide);
components.set('Motability7Buttons', Motability7Buttons);
components.set('Motability7List', Motability7List);
components.set('Motability7Switch', Motability7Switch);
components.set('OffersHero', OffersHero);
components.set('CarSelection', CarSelection);
components.set('CarSelectionList', CarSelectionList);
components.set('OffersList', OffersList);
components.set('OffersAchieving', OffersAchieving);
components.set('OffersAchievingList', OffersAchievingList);
components.set('OldOffersHero', OldOffersHero);
components.set('SelectedCarDetail', SelectedCarDetail);
components.set('SCarDetaiDescriptionSection', SCarDetaiDescriptionSection);
components.set('SCarDetailHeroSection', SCarDetailHeroSection);
components.set('SCarDetaiImagesSection', SCarDetaiImagesSection);
components.set('SCarDetaiSecondImageSection', SCarDetaiSecondImageSection);
components.set('SCarDetaiSwitch', SCarDetaiSwitch);
components.set('SCarDetaiTermsAndConditionsSection', SCarDetaiTermsAndConditionsSection);
components.set('roadside-assistance', roadsideassistance);
components.set('RoadsideAssistance', RoadsideAssistance);
components.set('RoadsideContactRoadside', RoadsideContactRoadside);
components.set('RoadsideHero', RoadsideHero);
components.set('RoadsideNeedServicing', RoadsideNeedServicing);
components.set('RoadsideBlock', RoadsideBlock);
components.set('service-and-maintenance', serviceandmaintenance);
components.set('ServiceAndMaintenance', ServiceAndMaintenance);
components.set('ServiceAndMaintenanceBookService', ServiceAndMaintenanceBookService);
components.set('ServiceAndMaintenanceHero', ServiceAndMaintenanceHero);
components.set('ServiceAppointment', ServiceAppointment);
components.set('ServiceAndMaintenanceStepItem', ServiceAndMaintenanceStepItem);
components.set('ServiceAndMaintenanceSteps', ServiceAndMaintenanceSteps);
components.set('service-plan', serviceplan);
components.set('PlanFindADealer', PlanFindADealer);
components.set('PlanHeroSection', PlanHeroSection);
components.set('PlanServicePlanHighlight', PlanServicePlanHighlight);
components.set('PlanScrollFixedImages', PlanScrollFixedImages);
components.set('PlanWarrantySection', PlanWarrantySection);
components.set('Button', Button);
components.set('CustomDropdown', CustomDropdown);
components.set('CustomInputDropdown', CustomInputDropdown);
components.set('Loader', Loader);
components.set('VinLookUp', VinLookUp);
components.set('warranty', warranty);
components.set('WarrantyAboutSection', WarrantyAboutSection);
components.set('WarrantyHeroSection', WarrantyHeroSection);
components.set('WarrantyHighlightSection', WarrantyHighlightSection);
components.set('WarrantyListSection', WarrantyListSection);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-EditFrame', StyleguideEditFrame);
components.set('Styleguide-LanguageSelector', StyleguideLanguageSelector);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Specimen', StyleguideSpecimen);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('OptimizedImage', OptimizedImage);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
